import { render, staticRenderFns } from "./AgentUpdateBadge.vue?vue&type=template&id=bdacd882&scoped=true"
import script from "./AgentUpdateBadge.vue?vue&type=script&lang=js"
export * from "./AgentUpdateBadge.vue?vue&type=script&lang=js"
import style0 from "./AgentUpdateBadge.vue?vue&type=style&index=0&id=bdacd882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdacd882",
  null
  
)

export default component.exports